const replaceHyphensWithSpaces = (url) => {
    const specificPath = url.split("/").pop();


    return specificPath;
}

  export default replaceHyphensWithSpaces;